<template>
  <!-- O alerta vermelho no título: no chassi das perguntas, não se via que era um erro (pedido do
       usuário) -->
  <ontos-ask-dialog v-if="shown" :title="$tt('change-refused')" :message="shown.message"
                    icon="mdi-alert-circle" icon-color="error" :actions="actions"
                    @pick="onPick($event)" @closed="close()">
    <!-- As falhas de campo como o formulário as mostra: o rótulo do campo e a frase em vermelho
         embaixo (escolha do usuário), e não numa linha só separada por pontos -->
    <template v-if="shown.fields.length">
      <div v-for="(failure, index) of shown.fields" :key="index" class="refusal-field">
        <span class="ontos-field-label">{{ failure.field }}</span>
        <div class="text-error">{{ failure.message }}</div>
      </div>
    </template>
    <template v-else>{{ shown.message }}</template>
  </ontos-ask-dialog>
</template>

<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator'
import AskDialog, {Ask, okAction} from '@/components/shared/AskDialog.vue'
import {Refusal, refusal} from '@/utils/refusal'

/**
 * A janela de recusa de uma gravação: o Salvar, o arrasto do Kanban, a situação (ver o `refuse`). Numa
 * janela, e não na barra de baixo, que sumia longe de onde se agiu (pedido do usuário).
 *
 * Uma só, no casco (o `App.vue` a desenha), lendo o estado de módulo do `refusal`. Por último no casco,
 * para abrir por cima da janela em que se gravou: o Vuetify dá foco e ESC só à de cima.
 */
@Component({name: 'ontos-refusal-dialog', components: {'ontos-ask-dialog': AskDialog}})
class RefusalDialog extends Vue {
  get shown(): Refusal | null {
    return refusal.value
  }

  /**
   * Só o OK; ou, quando quem gravou sabe abrir a edição do item recusado, "Editar" em destaque e o OK
   * discreto (escolha do usuário): a saída esperada é ir corrigir.
   */
  get actions(): Ask[] {
    if (!this.shown?.edit) return [okAction()]
    return [
      {value: 'ok', label: this.$tt('ok') as string, text: true},
      {value: 'edit', label: this.$tt('edit') as string, icon: 'mdi-pencil', color: 'primary'}
    ]
  }

  close() {
    refusal.value = null
  }

  /** Fecha antes de editar: a edição abre por cima da tela, e não desta janela. */
  onPick(action: string) {
    const edit = this.shown?.edit
    this.close()
    if (action === 'edit' && edit) edit()
  }
}

export default toNative(RefusalDialog)
</script>

<style scoped>
/* Uma falha de campo e a seguinte: o espaço entre uma e outra, como entre campos */
.refusal-field + .refusal-field {
  margin-top: 12px;
}
</style>
